var React                         = require("react");

var ExperienceCardDetails         = require("./experience_card_details");
var ChallengeCard                 = require("./challenge_card");
var ChallengeCardDetails          = require("./challenge_card_details");
var CardRatioContainer            = require("./card_ratio_container");
var ExperienceCounters            = require("./experience_counters");

var ExperienceCardContainer = React.createClass({
  PropTypes: {
    experience: React.PropTypes.object,
    experiencePath : React.PropTypes.object.isRequired,
    hideCounters: React.PropTypes.bool,
    homepageUrl: React.PropTypes.string.isRequired,
    shortCardDesignEnabled: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      experience: {},
      experiencePath: {}
    }
  },

  onExperienceCardClick: function(e) {
    e.preventDefault();
    window.history.replaceState({}, '', this.props.homepageUrl);
    window.location.href = this._getExperienceUrl();
  },

  render: function() {
    if (!this.props.experience.total_challenge_count) return null

    return (
      <div className="experience-card" key={this.props.experience.id}>
        <ChallengeCard id={"experience-" + this.props.experience.id}>
          <a onClick={this.onExperienceCardClick} href="#" className="card__link" aria-label={this.props.experience.name}>
            <CardRatioContainer shortCardDesignEnabled={this.props.shortCardDesignEnabled}>
              <div className="card__wrapper">
                <ChallengeCard.Image image={this.props.experience.image_url} />
                <div className="card__content card__text-wrapper card__content-border">
                  <ExperienceCardDetails>
                    {this._renderExperienceCounters()}
                    <ExperienceCardDetails.Headline
                      headline={this.props.experience.name}
                      shortCardDesignEnabled={this.props.shortCardDesignEnabled} />
                    {!this.props.shortCardDesignEnabled && 
                      <ChallengeCardDetails.Description description={this.props.experience.description} />}
                  </ExperienceCardDetails>
                  <div className="card__bottom-section">
                    <div className="card__cta card__cta">{this.props.experience.call_to_action}</div>
                  </div>
                </div>
              </div>
            </CardRatioContainer>
          </a>
        </ChallengeCard>
      </div>
    );
  },

  _renderExperienceCounters: function() {
    if(this.props.hideCounters) {
      return;
    }

    return <ExperienceCounters experience={this.props.experience} />
  },

  _getExperienceUrl: function() {
    return this.props.experiencePath({id: this.props.experience.id});
  }
});

module.exports = ExperienceCardContainer;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/experience_card_container.jsx